// extracted by mini-css-extract-plugin
export default {"app":"App_app__dG3Ha","container":"App_container__dVZxe","title":"App_title__fOVvb"};